if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.inventoryMap = {};

      const mapEl = this.querySelector('[data-variant-inventory-map]');
      if (mapEl) {
        try {
          const parsed = JSON.parse(mapEl.textContent);
          if (parsed && typeof parsed === 'object') this.inventoryMap = parsed;
        } catch (error) {
          this.inventoryMap = {};
        }
      }

      this.section = this.closest('.js-product');
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.onVariantChange = this.handleVariantChange.bind(this);

      if (this.section) {
        this.section.addEventListener('on:variant:change', this.onVariantChange);
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10) || 0,
        this.dataset.variantAvailable === 'true'
      );
    }

    disconnectedCallback() {
      if (this.section && this.onVariantChange) {
        this.section.removeEventListener('on:variant:change', this.onVariantChange);
      }
    }

    getInventory(variant) {
      if (!variant) return { inventory_quantity: 0, available: false };

      const fromMap = this.inventoryMap[variant.id] || this.inventoryMap[String(variant.id)];
      if (fromMap) {
        const qty = Number(fromMap.inventory_quantity);
        return {
          inventory_quantity: Number.isFinite(qty) ? Math.max(qty, 0) : 0,
          available: fromMap.available === true
        };
      }

      return {
        inventory_quantity: 0,
        available: variant.available === true
      };
    }

    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) {
        this.updateInventory(0, false);
        return;
      }

      const inventory = this.getInventory(variant);
      this.updateInventory(inventory.inventory_quantity, variant.available === true);
    }

    updateInventory(count, available) {
      if (!available) {
        this.hidden = true;
        this.setAttribute('data-inventory-level', 'none');
        if (this.inventoryNotice) this.inventoryNotice.innerText = '';
        return;
      }

      this.hidden = false;

      const quantity = Number.isFinite(count) ? Math.max(count, 0) : 0;
      const noticeText = theme.strings.inStockCount
        ? theme.strings.inStockCount.replace('[quantity]', quantity)
        : `In-stock (${quantity})`;

      this.setAttribute('data-inventory-level', 'in_stock');
      this.dataset.inventoryQuantity = String(count);
      this.dataset.variantAvailable = 'true';

      if (this.inventoryNotice) {
        this.inventoryNotice.innerText = noticeText;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
